import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "AddClientModal",
  tabindex: "-1",
  role: "dialog",
  ref: "addClientModalRef",
  "aria-labelledby": "tooltipmodal",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered modal-lg",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6 mb-3" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = {
  key: 0,
  class: "col-md-6 mb-3"
}
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = {
  key: 1,
  class: "col-md-6 mb-3"
}
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "col-md-6 mb-3" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "col-md-6 mb-3" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = {
  key: 2,
  class: "col-md-6 mb-3"
}
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = { class: "col-md-6 mb-3" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = { class: "col-md-6 mb-3" }
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = {
  key: 3,
  class: "col-md-6 mb-3"
}
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = {
  key: 4,
  class: "col-md-6 mb-3"
}
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = { class: "col-md-6 mb-3" }
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_30 = {
  key: 5,
  class: "col-md-6 mb-3"
}
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_32 = {
  key: 6,
  class: "col-md-6 mb-3"
}
const _hoisted_33 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_34 = {
  key: 7,
  class: "col-md-6 mb-3"
}
const _hoisted_35 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_36 = { class: "col-md-12 mb-3" }
const _hoisted_37 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_38 = {
  key: 8,
  class: "col-md-6"
}
const _hoisted_39 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_40 = { class: "col-md-12 mb-3 mt-3" }
const _hoisted_41 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.title), 1),
          _cache[1] || (_cache[1] = _createElementVNode("button", {
            class: "btn-close py-0",
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            ref: "clientForm",
            onSubmit: _ctx.addClient,
            "validation-schema": _ctx.clientSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Statut"),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "statut",
                      modelValue: _ctx.defaultStatut,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.defaultStatut) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.statut,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          placeholder: "Sélectionner le statut",
                          onSelect: _ctx.handleObjetInput
                        }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "estPublie",
                    class: "text-danger"
                  })
                ]),
                (_ctx.showAdditionalFields)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Nom "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "nomClient",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer le nom"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "nomClient",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showAdditionalFields)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Prénom "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "prenomClient",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer le prenom"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "prenomClient",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Adresse "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "adresseClient",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer l'adresse"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "adresseClient",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Email "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "emailClient",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer l'email"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "emailClient",
                      class: "text-danger"
                    })
                  ])
                ]),
                (_ctx.showAdditionalFields)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Sexe "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "sexe",
                          type: "text"
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              searchable: true,
                              options: ['Masculin', 'Féminin'],
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, { placeholder: "Sélectionner le sexe" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "sexe",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Téléphone 1 "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "telephone1",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le téléphone"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "telephone1",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Téléphone 2 ", -1)),
                    _createVNode(_component_Field, {
                      name: "telephone2",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le téléphone"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "telephone2",
                      class: "text-danger"
                    })
                  ])
                ]),
                (_ctx.showAdditionalFields)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Date de naissance "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "dateNais",
                          type: "date",
                          class: "form-control shadow-none fs-md-15 text-black"
                        })
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        name: "dateNais",
                        class: "text-danger"
                      })
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.showAdditionalFields)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Raison sociale "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "raisonSociale",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer la raison sociale"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "raisonSociale",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" IFU "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "ifu",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer l'ifu"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "ifu",
                      class: "text-danger"
                    })
                  ])
                ]),
                (!_ctx.showAdditionalFields)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Régistre de commerce "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "rccm",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer le régistre de commerce"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "rccm",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.showAdditionalFields)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Sigle "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "sigle",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer le sigle"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "sigle",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.showAdditionalFields)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Dénomination "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "denomination",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer la denomination"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "denomination",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Catégorie du client"),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "categorieClient" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.categorieClientOptions,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner la catégorie du client" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "categorieClient",
                      class: "text-danger"
                    })
                  ])
                ]),
                (!_ctx.showAdditionalFields)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Date de création "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "dateCreation",
                          type: "date",
                          class: "form-control shadow-none fs-md-15 text-black"
                        })
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        name: "dateCreation",
                        class: "text-danger"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _cache[19] || (_cache[19] = _createElementVNode("button", {
                      class: "btn btn-success me-3",
                      type: "submit"
                    }, " Ajouter un client ", -1)),
                    _createVNode(_component_router_link, {
                      to: "/clients/liste-clients",
                      class: "btn btn-danger"
                    }, {
                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                        _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                        _createElementVNode("span", { class: "position-relative" }, null, -1),
                        _createTextVNode("Annuler")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ], 512))
}